import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-subscription-payment',
  templateUrl: './subscription-payment.component.html',
  styleUrls: ['./subscription-payment.component.scss'],
  standalone: false
})
export class SubscriptionPaymentComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Subscription Pricing'}
  ];

  showMessages = false;
  messages: any[] = [];
  username: string = '';
  impersonatedEmail: any = null;

  pageName = 'Subscription Pricing';
  savedUserId: number = -1;
  savedUsername: string = '';
  savedFirstName: string = '';
  savedLastName: string = '';
  savedPhoneNumber: string = '';
  savedEmail:string = '';
  savedEIN: string = '';
  savedCompanyName: string = '';
  subscriptionPricePlans: any[] = [];
  savedPromoCode: string = '';
  currentIndex: number = -1;
  paymentTypeList: string[] = [];
  paymentMethodList: string[] = [];
  savedCardNumber: string = '';
  savedCardHolderName: string = '';
  savedExpirationDate: string = '';
  savedSecurityCode: string = '';
  savedBillingStreetAddressLine1: string = '';
  savedBillingStreetAddressLine2: string = '';
  savedBillingCity: string = '';
  savedBillingState: string = '';
  savedBillingZipCode: string = '';
  savedDefaultCheckbox: string = '';

  savedIsConsultant: string = 'N';
  // @ts-ignore
  constructor(private userService: UserService,
              private routerChild: Router,
              private auth2ServiceChild: Auth2Service,
              private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Subscription Pricing");
  }

  ngOnInit() {
    this.pageErrorMessages = [];
    //Get the Subscription Prices in a table
    this.username = this.auth2ServiceChild.getUsername();
    this.savedIsConsultant = this.auth2ServiceChild.getIsConsultant();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    if (this.impersonatedEmail != null && this.username != this.impersonatedEmail) {
      //impersonate emails are not allowed on this page
      this.pageErrorMessages.push({
        field: 'Impersonated Emails not allowed on page.',
        detail: 'Consultants are not allowed to activate their client subscriptions.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.routerChild.navigateByUrl('app/users/dashboard');
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })

    this.userService.getUserProfile(this.username).subscribe((userResult: any) => {
      if (userResult && userResult.body) {
        this.populateData(userResult.body);
        if (this.savedIsConsultant  == 'Y') {
          this.userService.getConsultantSubscriptionPricingV3(this.username).subscribe((result: any) => {
            if (result && result.body) {
              this.subscriptionPricePlans = result.body;
            }
          }, (err1: HttpErrorResponse) => {
            this.redirectToLogin(err1);
            this.pageErrorMessages.push({
              field: 'Subscription Plan Pricing API Error',
              detail: 'Failed to pull the Subscription Plan Pricing...',
              severity: 'error'
            });
            this.showErrorMessagesToUser();
          });
        } else {
          // @ts-ignore
          this.userService.getSubscriptionPricingV4(this.username).subscribe((result: any) => {
            if (result && result.body) {
              this.subscriptionPricePlans = result.body;
            }
          }, (err1: HttpErrorResponse) => {
            this.redirectToLogin(err1);
            this.pageErrorMessages.push({
              field: 'Subscription Plan Pricing API Error',
              detail: 'Failed to pull the Subscription Plan Pricing...',
              severity: 'error'
            });
            this.showErrorMessagesToUser();
          });
        }
      }
    }, (error: HttpErrorResponse) => {

    });

  }

  private populateData(dto: any) {
    let userDto: any = null;
    if (dto.userDto) {
      userDto = dto.userDto
    } else {
      userDto = dto;
    }

    if (userDto.isConsultant) {
      this.savedIsConsultant = userDto.isConsultant;
    }

    if (userDto.userId) {
      this.savedUserId = userDto.userId;
    }

    if (userDto.firstName) {
      this.savedFirstName = userDto.firstName;
    }

    if (userDto.lastName) {
      this.savedLastName = userDto.lastName;
    }

    if (userDto.email) {
      this.savedEmail = userDto.email;
    }

    if (userDto.phoneNumber) {
      this.savedPhoneNumber = userDto.phoneNumber;
    }

    if (userDto.phoneNumber) {
      this.savedPhoneNumber = userDto.phoneNumber;
    }


  }

  checkoutSessionV3(subscriptionPricePlan: any): void {
    this.pageErrorMessages = [];
    if (this.savedIsConsultant == 'Y') {
      this.userService.checkoutSessionConsultantV3(this.username, subscriptionPricePlan['subscriptionPlanName'])
        .subscribe((result: any) => {
          if (result && result.body && result.body.url) {
            // @ts-ignore
            window.open(result.body.url, '_self');
          }
        }, (err1: HttpErrorResponse) => {
          this.redirectToLogin(err1);
          if (err1.status == 400) {
            this.pageErrorMessages.push({
              field: 'Subscription Plan Promo Code Error',
              detail: err1.error.message,
              severity: 'error'
            });
          } else {
            this.pageErrorMessages.push({
              field: 'Subscription Plan Checkout Session API Error',
              detail: 'Failed to create a checkout session. ' + err1.error.message,
              severity: 'error'
            });
          }
          this.showPageErrorMessagesToUser();
        });
    } else {
      const promoCodeTxtEl = document.getElementById('promo-code-text-id');
      // @ts-ignore
      let promoCodeTxt: string = promoCodeTxtEl.value;

      this.userService.checkoutSessionV3(this.username, subscriptionPricePlan['subscriptionPlanName'], promoCodeTxt)
        .subscribe((result: any) => {
          if (result && result.body && result.body.url) {
            // @ts-ignore
            window.open(result.body.url, '_self');
          }
        }, (err1: HttpErrorResponse) => {
          this.redirectToLogin(err1);
          if (err1.status == 400) {
            this.pageErrorMessages.push({
              field: 'Subscription Plan Promo Code Error',
              detail: err1.error.message,
              severity: 'error'
            });
          } else {
            this.pageErrorMessages.push({
              field: 'Subscription Plan Checkout Session API Error',
              detail: 'Failed to create a checkout session. ' + err1.error.message,
              severity: 'error'
            });
          }
          this.showPageErrorMessagesToUser();
        });
    }
  }

  submitPromoCode(): void {
    //Extract Promo Code from the textbox
    //Validate First Name
    console.log('Validating Promo Code');
    const promoCodeTxtEl = document.getElementById('promo-code-text-id');
    // @ts-ignore
    let promoCodeTxt: string = promoCodeTxtEl.value;
    console.log('promoCodeTxt: ' + promoCodeTxt);
    if (!promoCodeTxt) {
      promoCodeTxt = '';
    }

    //Submit to API to return the new subscription pricing for each length after verifying the promo code
    //Get the Subscription Prices in a table
    const username = localStorage.getItem('username');
    // @ts-ignore
    this.userService.getSubscriptionPricingWithPromoCode(username, promoCodeTxt)
      .subscribe((result: any) => {
      if (result && result.body) {
        // updating the current subscription price plans given a valid promo code
        if (result.body.length > 0) {// A nonempty array indicates a valid promoCode
          this.subscriptionPricePlans = result.body;
        } else {
          console.log('Promo Code is not valid or expired...');
        }
      }
    }, (err1: HttpErrorResponse) => {
        this.redirectToLogin(err1);
      console.log('Error: ' + JSON.stringify(err1));
    });
  }

  trackSubscriptionPricePlans(index: number): void {
    //Clear SubscriptionPricePlan Radio Buttons
    for (const subscriptionPricePlan of this.subscriptionPricePlans) {
      subscriptionPricePlan.checked = false;
    }
    const subscriptionPricePlanEl = document.getElementById('subscription-price-plans-checkbox-' + index + '-id');
    // @ts-ignore
    const subscriptionPricePlanChecked = subscriptionPricePlanEl.checked;
    this.subscriptionPricePlans[index]['checked'] = subscriptionPricePlanChecked;
  }

  onClearPromoCode(): void {
    this.savedPromoCode = '';
  }

  onCancel(): void {
    this.routerChild.navigateByUrl('app/users/dashboard');
  }
}
